import { UIButton } from '../common/ui/uiButton';
import { UIImage } from '../common/ui/uiImage';
import { UIPanel } from '../common/ui/uiPanel';
import { UIPanelButton } from '../common/ui/uiPanelButton';
import { UIScreen } from '../common/ui/uiScreen';
import { UIText } from '../common/ui/uiText';
import { getTimeString, numberWithCommas } from '../common/util';
import { SolitairePanel } from './solitairePanel';
// import { LeaderboardPanel } from '../common/leaderboardPanel';
// import { Site } from 'src/site/site';
import { SoundManager } from '../common/audio/soundManager';
import { GameStyle } from './gameStyle';
import { Game, GameMode } from './game';
import { TournamentType } from './solitaire';
import { Server } from '../../server/server';
import { AppConfig } from '../../app/AppConfig';

export class GameScreen extends UIScreen {
  protected finishButton: UIButton;
  protected playWithFriendsButton: UIPanelButton;
  protected scoreText: UIText;
  protected timeText: UIText;
  protected bonusText: UIText;
  protected timeLabel: UIText;
  protected undoButton: UIPanelButton;
  protected menuPanel: UIPanel;
  protected toggleSoundOnIcon: UIImage;
  protected toggleSoundOffIcon: UIImage;
  protected toggleAutoplayButton: UIPanelButton;
  protected toggleAutoplayOnIcon: UIImage;
  protected toggleAutoplayOffIcon: UIImage;
  protected timePanel: UIPanel;
  protected bonusPanel: UIPanel;
  scorePanel: UIPanel;
  protected playPlaceButton: UIPanelButton;

  public build() {
    let background = new UIPanel({
      color : GameStyle.backgroundColors.game.outer,
      fitParent : {left : 0, top : 0, right : 0, bottom : 0},
      parent : this
    });

    let innerPanel = new UIPanel({
      color : GameStyle.backgroundColors.game.inner,
      fitParent : {left : 0, top : 60, right : 0, bottom : 60},
      radius: 30,
      parent : this
    });

    let solitairePanel = new SolitairePanel({
      fitParent : {left : 10, top : 70, right : 10, bottom : 70},
      parent : this
    });

    this.buildTopBar();
    this.buildBottomBar();
    this.buildMenu();
  }

  protected buildTopBar() {
    let topbar = new UIPanel({
      fitParent: {left: 0, right: 0, top: -1, bottom: -1},
      size: {x: 0, y: 60},
      parent : this
    });

    this.scorePanel = new UIPanel({
      anchor: {x: 0.5, y: 0.5},
      pivot: {x: 0.5, y: 0.5},
      size: {x: 80, y: 40},
      radius: GameStyle.header.panel.radius,
      color: GameStyle.header.panel.color,
      parent : topbar
    });

    let scoreLabel = new UIText({
      text : 'SCORE',
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      position: {x: 0, y: 1},
      fontFamily: GameStyle.header.label.fontFamily,
      fontSize: GameStyle.header.label.fontSize,
      color: GameStyle.header.label.color,
      parent : this.scorePanel
    });

    this.scoreText = new UIText({
      text : '123',
      anchor: {x: 0.5, y: 0.5},
      pivot: {x: 0.5, y: 0.5},
      position: {x: 0, y: 7},
      fontFamily: GameStyle.header.value.fontFamily,
      fontSize: GameStyle.header.value.fontSize,
      color: GameStyle.header.value.color,
      parent : this.scorePanel
    });

    this.timePanel = new UIPanel({
      size : {x : 80, y : 40},
      position : {x : 60, y : 10},
      radius: GameStyle.header.panel.radius,
      color: GameStyle.header.panel.color,
      parent : topbar
    });

    this.timeLabel = new UIText({
      text : 'TIME',
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      position: {x: 0, y: 1},
      fontFamily: GameStyle.header.label.fontFamily,
      fontSize: GameStyle.header.label.fontSize,
      color: GameStyle.header.label.color,
      parent : this.timePanel
    });

    this.timeText = new UIText({
      text : '1:23',
      anchor: {x: 0.5, y: 0.5},
      pivot: {x: 0.5, y: 0.5},
      position: {x: 0, y: 7},
      fontFamily: GameStyle.header.value.fontFamily,
      fontSize: GameStyle.header.value.fontSize,
      color: GameStyle.header.value.color,
      parent : this.timePanel
    });

    this.bonusPanel = new UIPanel({
      size : {x : 80, y : 40},
      position : {x : -60, y : 10},
      anchor : {x : 1, y : 0},
      pivot : {x : 1, y : 0},
      radius: GameStyle.header.panel.radius,
      color: GameStyle.header.panel.color,
      parent : topbar
    });

    let bonusLabel = new UIText({
      text : 'BONUS',
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      position: {x: 0, y: 1},
      fontFamily: GameStyle.header.label.fontFamily,
      fontSize: GameStyle.header.label.fontSize,
      color: GameStyle.header.label.color,
      parent : this.bonusPanel
    });

    this.bonusText = new UIText({
      text : '+12',
      anchor: {x: 0.5, y: 0.5},
      pivot: {x: 0.5, y: 0.5},
      position: {x: 0, y: 7},
      fontFamily: GameStyle.header.value.fontFamily,
      fontSize: GameStyle.header.value.fontSize,
      color: GameStyle.header.value.color,
      parent : this.bonusPanel
    });

    this.playPlaceButton = new UIPanelButton({
      size: {x: 40, y: 40},
      position: {x: 10, y: 10},
      callback : (btn:UIPanelButton) => {
        this.onPPMenu();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      borderWidth: GameStyle.dialog.button.borderWidth,
      borderColor: GameStyle.dialog.button.borderColor,
      parent : topbar
    });

    let playPlaceIcon = new UIImage({
      url : '/playplace.png',
      parent : this.playPlaceButton
    });

    let pauseButton = new UIPanelButton({
      anchor: {x: 1, y: 0},
      pivot: {x: 1, y: 0},
      size: {x: 40, y: 40},
      position: {x: -10, y: 10},
      callback : (btn:UIPanelButton) => {
        this.onPause();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      borderWidth: GameStyle.dialog.button.borderWidth,
      borderColor: GameStyle.dialog.button.borderColor,
      parent : topbar
    });

    let menuIcon = new UIImage({
      url : require('./assets/menu.png'),
      parent : pauseButton
    });
  }

  protected buildBottomBar() {
    let bottombar = new UIPanel({
      fitParent: {left: 0, right: 0, top: -1, bottom: -1},
      size: {x: 0, y: 60},
      anchor: {x: 0, y: 1},
      pivot: {x: 0, y: 1},
      parent : this
    });

    // let leaderboard = new LeaderboardPanel({
    //   fitParent: {left: 10, right: 110, top: 10, bottom: 10},
    //   callback: ()=>{
    //     this.onLeaderboardClick();
    //   },
    //   lifetimeScoreCookieId: 'SolitaireLifetimeScore',
    //   fontFamily: GameStyle.leaderboard.fontFamily,
    //   fontSize: GameStyle.leaderboard.fontSize,
    //   nameColor: GameStyle.leaderboard.nameColor,
    //   localNameColor: GameStyle.leaderboard.localNameColor,
    //   scoreColor: GameStyle.leaderboard.scoreColor,
    //   panelColor: GameStyle.leaderboard.panelColor,
    //   panelRadius: GameStyle.leaderboard.panelRadius,
    //   parent : bottombar
    // });

    // this.playWithFriendsButton = new UIPanelButton({
    //   text: 'Play With\nFriends',
    //   anchor: {x: 0.5, y: 0.5},
    //   pivot: {x: 0.5, y: 0.5},
    //   size: {x: 90, y: 40},
    //   position: {x: 0, y: 0},
    //   callback : (btn:UIPanelButton) => {
    //     this.onPlayWithFriends();
    //   },
    //   panelColors : GameStyle.playWithFriends.panelColors,
    //   borderColor: GameStyle.playWithFriends.borderColor,
    //   borderWidth: GameStyle.playWithFriends.borderWidth,
    //   textOffset: GameStyle.playWithFriends.textOffset,
    //   fontFamily: GameStyle.playWithFriends.fontFamily,
    //   fontSize: GameStyle.playWithFriends.fontSize,
    //   radius: GameStyle.playWithFriends.radius,
    //   parent : bottombar
    // });

    let finishButton = new UIPanelButton({
      anchor: {x: 1, y: 0},
      pivot: {x: 1, y: 0},
      size: {x: 40, y: 40},
      position: {x: -60, y: 10},
      callback : (btn:UIPanelButton) => {
        this.onFinish();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      borderWidth: GameStyle.dialog.button.borderWidth,
      borderColor: GameStyle.dialog.button.borderColor,
      parent : bottombar
    });

    let finishIcon = new UIImage({
      url : require('./assets/tournament.png'),
      parent : finishButton
    });

    this.undoButton = new UIPanelButton({
      anchor: {x: 1, y: 0},
      pivot: {x: 1, y: 0},
      size: {x: 40, y: 40},
      position: {x: -10, y: 10},
      callback : (btn:UIPanelButton) => {
        this.onUndo();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      borderWidth: GameStyle.dialog.button.borderWidth,
      borderColor: GameStyle.dialog.button.borderColor,
      parent : bottombar
    });

    let undoIcon = new UIImage({
      url : require('./assets/undo.png'),
      parent : this.undoButton
    });
  }

  protected buildMenu() {
    this.menuPanel = new UIPanel({
      size: {x: 40, y: 140},
      position: {x: 10, y: 60},
      parent : this
    });

    let flipLayoutButton = new UIPanelButton({
      size : {x : 40, y : 40},
      position : {x : 0, y : 0},
      callback : () => {
        this.menuPanel.visible = false;
        Game.instance.solitaire.toggleFlipLayout();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      borderWidth: GameStyle.dialog.button.borderWidth,
      borderColor: GameStyle.dialog.button.borderColor,
      parent : this.menuPanel
    });

    let flipLayoutIcon = new UIImage({
      url : require('./assets/fliplayout.png'),
      parent : flipLayoutButton
    });

    let toggleSoundButton = new UIPanelButton({
      size : {x : 40, y : 40},
      position : {x : 0, y : 50},
      callback : () => {
        this.menuPanel.visible = false;
        Game.instance.solitaire.toggleSfxOn();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      borderWidth: GameStyle.dialog.button.borderWidth,
      borderColor: GameStyle.dialog.button.borderColor,
      parent : this.menuPanel
    });

    this.toggleSoundOnIcon = new UIImage({
      url : require('./assets/togglesoundon.png'),
      parent : toggleSoundButton
    });

    this.toggleSoundOffIcon = new UIImage({
      url : require('./assets/togglesoundoff.png'),
      parent : toggleSoundButton
    });

    this.toggleAutoplayButton = new UIPanelButton({
      size : {x : 40, y : 40},
      position : {x : 0, y : 100},
      callback : () => {
        this.menuPanel.visible = false;
        Game.instance.solitaire.toggleAutoplay();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      borderWidth: GameStyle.dialog.button.borderWidth,
      borderColor: GameStyle.dialog.button.borderColor,
      parent : this.menuPanel
    });

    this.toggleAutoplayOnIcon = new UIImage({
      url : require('./assets/toggleautoplayon.png'),
      parent : this.toggleAutoplayButton
    });

    this.toggleAutoplayOffIcon = new UIImage({
      url : require('./assets/toggleautoplayoff.png'),
      parent : this.toggleAutoplayButton
    });
  }

  private onEventUpdated(data: any) {
    if(data.action == 'connect' || data.action == 'disconnect' || data.action == 'presence')
      return;

    let dot = new UIPanel({
      size: {x: 10, y: 10},
      position: {x: 35, y: 0},
      radius: 5,
      color: 'yellow',
      parent : this.playPlaceButton
    });
  }
  
  public onWake() {
    this.menuPanel.visible = false;

    let qs = new URLSearchParams(window.location.search);
    if(qs.has('room')) {
      Game.instance.solitaire.clear();
      // Game.instance.joinRoom(qs.get('room'));
    }
    else
      Game.instance.start();

    this.onEventUpdated = this.onEventUpdated.bind(this);
    Server.messages.addEventListener('chat-started', this.onEventUpdated);
    Server.messages.addEventListener('chat-updated', this.onEventUpdated);
    Server.user.addEventListener('friend-updated', this.onEventUpdated);
  }

  public update() {
    super.update();

    let sol = Game.instance.solitaire;

    if (sol.playingTournament && sol.tournamentType === TournamentType.Timed) {
      this.timeLabel.text = 'TIME';
      this.timeText.text = `${getTimeString(sol.tournamentTimeLeft)}`;
    }
    else if (sol.playingTournament && sol.tournamentType === TournamentType.Games) {
      this.timeLabel.text = 'GAME';
      this.timeText.text = `${sol.tournamentGamesPlayed} of ${sol.tournamentGamesToPlay}`;
    }
    else if (sol.timedGame && sol.passesAllowed === 0) {
      this.timeLabel.text = 'TIME';
      this.timeText.text = `${getTimeString(sol.gameTime)}`;
    }
    else {
      this.timeLabel.text = 'DECK PASS';
      if (sol.passesAllowed === 0) {
        this.timeText.text = sol.passes.toString();
      }
      else {
        this.timeText.text = `${sol.passes} of ${sol.passesAllowed}`;
      }
    }

    this.bonusText.text = '+' + sol.getCountdownPoints().toString();

    let score = sol.baseScore;
    if (sol.playingTournament) {
      score += sol.tournamentTotalScore;
      if (!Game.instance.playing)
        score -= sol.baseScore;
    }

    this.scoreText.text = `${numberWithCommas(score)}`;

    this.scorePanel.visible = sol.scoring;
    this.bonusPanel.visible = sol.scoring;

    this.timePanel.anchor.x = sol.scoring ? 0 : 0.5;
    this.timePanel.pivot.x = sol.scoring ? 0 : 0.5;
    this.timePanel.position.x = sol.scoring ? 60 : 0;

    // this.playWithFriendsButton.visible = !Site.room.isActive();

    this.undoButton.disabled = !Game.instance.solitaire.canUndo();
  }

  protected onMenu() {
    this.menuPanel.visible = !this.menuPanel.visible;

    if(this.menuPanel.visible) {
      this.toggleSoundOnIcon.visible = SoundManager.instance.sfxOn;
      this.toggleSoundOffIcon.visible = !SoundManager.instance.sfxOn;
      // this.toggleAutoplayButton.disabled = Site.room.isActive();
      this.toggleAutoplayOnIcon.visible = Game.instance.solitaire.useAutoPlay;
      this.toggleAutoplayOffIcon.visible = !Game.instance.solitaire.useAutoPlay;
    }
  }

  protected onPause() {
    this.pause();

    Game.instance.pauseDialog.showModal((action:string)=>{
      if(action == 'restart') {
        Game.instance.askQuestion('Start a new game?', (response:string)=>{
          if(response == 'Yes')
            Game.instance.selectGameMode();
          else
            this.resume();
        });
      }
      else if(action == 'quit') {
        Game.instance.askQuestion('Quit the game and\nreturn to Play Place?', (response:string)=>{
          if(response == 'Yes')
            Game.instance.quit();
          else
            this.resume();
        });
      } 
      else if(action == 'options') {
        Game.instance.gameOptionsDialog.showModal(()=>{
          this.onPause();
        });
      }
      else
        this.resume();
    });
  }

  protected onPPMenu() {
    this.pause();

    Game.instance.playPlaceMenu.showModal((action:string)=>{
      if (action) {
        Game.instance.askQuestion('Quit the game and\nreturn to Play Place?', (response:string)=>{
          if(response == 'Yes') {
            let menu = AppConfig.menu;

            if(action == menu[0].text)
              window.open(menu[0].to, '_self');
            else if(action == menu[1].text)
              window.open(menu[1].to, '_self');
            else if(action == menu[2].text)
              window.open(menu[2].to, '_self');
            else if(action == menu[3].text)
              window.open(menu[3].to, '_self');
            else if(action == menu[5].text)
              window.open(menu[5].to, '_self');
            else if(action == menu[6].text)
              window.open(menu[6].to, '_self');
          }
          else
            this.resume();
        });
      }
      else
        this.resume();
    });
  }

  public onLeaderboardClick() {
    // if(Site.room.isActive())
    //   Game.instance.showRoom();
    // else {
    //   Game.instance.askQuestion('Quit the game and\nreturn to Play Place?', (response:string)=>{
    //     if(response == 'Yes')
    //       Game.instance.quit();
    //   });
    // }
  }

  protected onPlayWithFriends() {
    // Game.instance.askQuestion('Start a new game with friends?', (response:string)=>{
    //   if(response == 'Yes') {
    //     Game.instance.createRoom((success:boolean)=>{
    //       if(success)
    //         Game.instance.solitaire.clear();
    //     });
    //   }
    // });
  }

  protected onUndo() {
    Game.instance.solitaire.undo();
  }

  public pause() {
    Game.instance.started = false;
  }

  public resume() {
    Game.instance.started = true;
  }

  protected onFinish() {
    this.pause();
    let solitaire = Game.instance.solitaire;

    let msg = '';
    if (solitaire.playingTournament) {
      let askFinish = (solitaire.tournamentType !== TournamentType.Timed) &&
                      (solitaire.tournamentGamesPlayed === solitaire.tournamentGamesToPlay);
      msg = askFinish ? 'Finish the tournament?' : 'Start next game in tournament?';
      if(Game.instance.gameMode === GameMode.Arcade)
        msg = 'Shuffle the deck and deal a new game?\nYour score will remain.'
    }
    else {
      msg = 'Do you want to finish this game?'
    }

    Game.instance.askQuestion(msg, (response:string)=>{
      if(response == 'Yes')
        Game.instance.finish();
      else
        this.resume();
    })
  }
}